import React from "react";
import { Search, Plus, FileText, BarChart, Package, Settings, ShoppingCart, PieChart } from "lucide-react";

const StepsSection = () => {
    const steps = [
      {
        id: 1,
        title: "DASHBOARD",
        description: "One-page analytics to track purchases",
        icon: BarChart,
        color: "#ff5733",
        bgColor: "#fef2f0",
      },
      {
        id: 2,
        title: "MASTERS",
        description: "Create Products, Categories, Customers, Units, Taxes",
        icon: Settings,
        color: "#ffb400",
        bgColor: "#fff9e6",
      },
      {
        id: 3,
        title: "PURCHASE",
        description: "Manage purchase bills and supplier payments",
        icon: ShoppingCart,
        color: "#00cc66",
        bgColor: "#e6f9ef",
      },
      {
        id: 4,
        title: "SALES",
        description: "Create invoices with barcode, credit sales, and more",
        icon: FileText,
        color: "#00aaff",
        bgColor: "#e6f7ff",
      },
      {
        id: 5,
        title: "REPORTS",
        description: "100+ reports including GST reports",
        icon: PieChart,
        color: "#6b48ff",
        bgColor: "#f0edff",
      },
    ];
  
    const styles = {
      container: {
        backgroundColor: "#ffffff",
        padding: "40px 30px",
        borderRadius: "16px",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
        margin: "30px auto",
        border: "1px solid #edf2f7",
        maxWidth: "1200px",
      },
      header: {
        display: "flex",
        alignItems: "center",
        gap: "20px",
        marginBottom: "40px",
        justifyContent: "center",
      },
      title: {
        fontSize: "36px",
        fontWeight: "700",
        color: "#2d3748",
        letterSpacing: "1.5px",
        textTransform: "uppercase",
        background: "linear-gradient(90deg, #ff5733, #6b48ff)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      },
      stepsContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "25px",
        position: "relative",
        padding: "20px 0",
      },
      step: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flex: 1,
        position: "relative",
        zIndex: 2,
        transition: "transform 0.3s ease",
      },
      stepIcon: {
        width: "90px",
        height: "90px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "20px",
        border: "4px solid",
        transition: "all 0.4s ease",
        cursor: "pointer",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      },
      stepTitle: {
        fontSize: "16px",
        fontWeight: "600",
        marginBottom: "10px",
        textAlign: "center",
        color: "#2d3748",
        textTransform: "uppercase",
      },
      stepDescription: {
        fontSize: "12px",
        color: "#718096",
        textAlign: "center",
        lineHeight: "1.6",
        maxWidth: "160px",
        fontWeight: "400",
      },
      progressLine: {
        position: "absolute",
        top: "45px",
        left: "8%",
        right: "8%",
        height: "6px",
        background: "linear-gradient(to right, #ff5733 20%, #ffb400 40%, #00cc66 60%, #00aaff 80%, #6b48ff 100%)",
        borderRadius: "3px",
        zIndex: 1,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      },
      arrow: {
        position: "absolute",
        right: "-15px",
        top: "50%",
        transform: "translateY(-50%)",
        fontSize: "28px",
        color: "#a0aec0",
        fontWeight: "bold",
        transition: "0.3s ease",
      },
    };
  
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Steps</h1>
        </div>
      <div style={styles.stepsContainer}>
        <div style={styles.divider}></div>
          <div style={styles.progressLine}></div>
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={step.id} style={styles.step} onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}>
                <div
                  style={{
                    ...styles.stepIcon,
                    backgroundColor: step.bgColor,
                    borderColor: step.color,
                    color: step.color,
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "scale(1.12)";
                    e.currentTarget.style.backgroundColor = step.color;
                    e.currentTarget.style.color = "#ffffff";
                    e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.2)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.backgroundColor = step.bgColor;
                    e.currentTarget.style.color = step.color;
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
                  }}
                >
                  <IconComponent size={36} />
                </div>
                <div style={styles.stepTitle}>{step.title}</div>
                <div style={styles.stepDescription}>{step.description}</div>
                {index < steps.length - 1 && <div style={styles.arrow}>→</div>}
              </div>
            );
          })}
        </div>
      </div>
    );
  };
export default StepsSection;